import { render } from "./indexpage.vue?vue&type=template&id=681e67ce&scoped=true"
import script from "./indexpage.vue?vue&type=script&lang=js"
export * from "./indexpage.vue?vue&type=script&lang=js"

import "./indexpage.vue?vue&type=style&index=0&id=681e67ce&scoped=true&lang=css"

import exportComponent from "C:\\GigLabs\\CIMS\\CIMS-MakProd\\gig.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-681e67ce"]])

export default __exports__